<template>
  <v-tooltip bottom v-if="show">
    <template v-slot:activator="{ on }">
      <v-icon :class="'no-available-seats ' + additionalClass" v-on="on">warning</v-icon>
    </template>
    <span>{{ this.$t("global.not_available_seats") }}</span>
  </v-tooltip>
</template>

<script>
export default {
  inheritAttrs: true,

  props: {
    show: {
      type: Boolean,
      required: true
    },

    additionalClass: {
      type: String
    }
  }
}
</script>
